import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import '../../microservice/container/sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from '../../container/Sidebar/Sidebar';
import { useTranslation } from "react-i18next";
import '../../Style/defaultstyle.scss'
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function MSA2VN() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("한비로 마이크로서비스 기반 개발이란")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">CQRS</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>Command and Query Responsibility Segregation (Lệnh và Truy vấn)</p>
                            <p class='typo-14'>• Lệnh: thao tác thay đổi dữ liệu (Create, Update, Delete)</p>
                            <p class='typo-14'>• Truy vấn: thao tác truy vấn dữ liệu (Read) </p>
                            <p class='typo-14'>• Phân tách trách nhiệm của các thao tác lệnh và truy vấn</p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/cqrs.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">EventSourcing</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>Lưu tất cả các sự kiện xảy ra theo thứ tự đã phát sinh</p>
                            <p class='typo-14'>Không thực hiện các phép cập nhật hay xóa các sự kiện </p>
                            <p class='typo-14'>Event sourcing có khả năng mở rộng cao và hỗ trợ xử lý thay đổi phân tán </p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/event-source.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">API Gateway</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>Microservices giao tiếp qua API </p>
                            <p class='typo-14'>Phân loại theo URL: phân biệt và định tuyến giữa a.vora.net và b.vora.net</p>
                            <p class='typo-14'>Theo module (theo Prefix / theo Host): phân biệt và định tuyến giữa a.vora.net/a và a.vora.net/b </p>
                            <p class='typo-14'>Quản lý nhiều endpoint dịch vụ và REST API </p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/api-gateway.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Containers, Docker và Kubernetes</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>POD của Kubernetes nhỏ gọn và nhẹ hơn máy chủ ảo, phù hợp cho microservices </p>
                            ` }}></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Các API được cung cấp dưới dạng dịch vụ serverless</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>POD của Kubernetes nhỏ gọn và nhẹ hơn máy chủ ảo, phù hợp cho microservices </p>
                            <p class='typo-14'>Chỉ khởi tạo khi ứng dụng cần thiết </p>
                            <p class='typo-14'>Khi không hoạt động, không phát sinh chi phí (tùy theo dịch vụ, có thể phát sinh chi phí lưu trữ) </p>
                            <p class='typo-14'>Rút ngắn thời gian phát triển và chi phí</p><br>

                            <div style="display: grid; grid-template-columns: auto auto;">
                                <p class='typo-14'>• Identity : OAuth</p>
                                <p class='typo-14'>• Core Storage (S3)</p>
                                <p class='typo-14'>• Directory</p>
                                <p class='typo-14'>• Simple URL Shortner</p>
                                <p class='typo-14'>• IAM (Identity and Access Management)</p>
                                <p class='typo-14'>• Generate QR Code</p>
                                <p class='typo-14'>• Event Sourcing</p>
                                <p class='typo-14'>• Business Process</p>
                                <p class='typo-14'>• Long-running</p>
                                <p class='typo-14'>• Automation Rule</p>
                                <p class='typo-14'>• Messaging :</p>
                                <p class='typo-14'>• Email</p>
                                <p class='typo-14' style="margin-left: 15px">• Topics</p>
                                <p class='typo-14'>• SMS</p>
                                <p class='typo-14' style="margin-left: 15px">• Queues</p>
                                <p class='typo-14'>• DNS</p>
                                <p class='typo-14'style="margin-left: 15px">• Incoming Webhooks</p>
                                <p class='typo-14'>• IOT</p>
                                <p class='typo-14' style="margin-left: 15px">• Outgoing Webhooks</p>
                                <p class='typo-14'>• Search query</p>
                                <p class='typo-14' style="margin-left: 15px">• Scheduler</p>
                                <p class='typo-14'>• Rate Limiting</p>
                            </div>
                            
                            ` }}></BoxText>

                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};


const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const Image = styled.img`
  width: 100%;
`

export default MSA2VN;